module.exports = __webpack_public_path__ + "img/pasture_brachiaria_middle.20ffc06e.webp";